// extracted by mini-css-extract-plugin
module.exports = {"grid":"label-alumni-grid-module--grid--2TqaQ"};